<div class="wc-footer" data-testid="dashboard-footer">
  <footer>
    <div id="spanCopyright" data-testid="copyright-text">
      &copy; MC Trade {{ currentYear }}
    </div>
    <div id="spanWlVersion" data-testid="version-text">
      {{ appVersion }}
    </div>
  </footer>
</div>
